<template>
  <div class="comment__idea-audit">
    <div class="comment__audit-compare-content">
      <div class="comment__idea-size">
        <TShortComponent
          :size="beforeSize ?? 'none'"
          :label="beforeSize || '--'"
          class="is-opacity"
        />
      </div>
      <icon
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
        class="comment__audit-compare-content__arrow"
      />
      <div class="comment__idea-size">
        <TShortComponent
          :size="afterSize ?? 'none'"
          :label="afterSize || '--'"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import TShortComponent from "@/components/TShort/index.vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeSize = computed(() => props.comment.ideaAuditRecord?.before?.size ?? null)
const afterSize = computed(() => props.comment.ideaAuditRecord?.after?.size ?? null)
</script>
